"use strict";

var _classCallCheck = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = __importStar(require("@ryerson/frontend.theme"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var common_constants_1 = require("@ryerson/common.constants");

var PageLayout = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmax-width: 800px;\n\tmargin: auto;\n\tpadding: 20px;\n"])));
var LogoArea = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\ttext-align: center;\n\t", "\n"])), function (props) {
  var company = props.company;

  if (company === "ryerson") {
    return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\tpadding: 60px 0px;\n\t\t\t"])));
  }

  if (company === "southernToolSteel") {
    return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\tpadding: 0px;\n\t\t\t"])));
  }
});

var ErrorBoundary = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(ErrorBoundary, _react_1$default$Comp);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    if (!props.company) {
      props.company = "ryerson";
    }

    _this = _super.call(this, props);
    _this.state = {
      hasError: undefined,
      error: undefined,
      errorInfo: undefined
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a, _b, _c;

      if (this.state.hasError) {
        var COMPANY_PHONES = common_constants_1.PhoneNumbers.PHONE_NUMBERS[this.props.company];
        return (0, jsx_runtime_1.jsx)(frontend_theme_1.default, {
          themeName: frontend_theme_1.ThemeNames[this.props.company],
          children: (0, jsx_runtime_1.jsxs)(PageLayout, {
            children: [(0, jsx_runtime_1.jsxs)(LogoArea, Object.assign({}, this.props, {
              children: [this.props.company === "ryerson" && (0, jsx_runtime_1.jsx)(frontend_assets_1.RyersonLogo, {
                width: "60%"
              }), this.props.company === "southernToolSteel" && (0, jsx_runtime_1.jsx)(frontend_assets_1.STSLogo, {
                width: "80%"
              })]
            })), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              variant: "h4",
              children: "Something went wrong"
            }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              variant: "p",
              children: ["Please refresh the page and try again. Still seeing this message and need assistance? You can reach out to us by sending an email to shop@", (_a = this.props.company) === null || _a === void 0 ? void 0 : _a.toLowerCase(), ".com or giving us a call at\xA0", COMPANY_PHONES.us.number, "."]
            }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              variant: "h4",
              children: "Algo sali\xF3 mal"
            }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              variant: "p",
              children: ["Actualice la p\xE1gina y vuelva a intentarlo. Sigo viendo este mensaje y \xBFnecesita ayuda? Puede comunicarse con nosotros enviando un correo electr\xF3nico a shop@", (_b = this.props.company) === null || _b === void 0 ? void 0 : _b.toLowerCase(), ".com o ll\xE1menos al\xA0", COMPANY_PHONES.mx.number, "."]
            }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              variant: "h4",
              children: "Une erreur s'est produite"
            }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              variant: "p",
              children: ["Veuillez actualiser la page et r\xE9essayer. Je vois toujours ce message et besoin d'assistance? Vous pouvez nous joindre en envoyant un courriel \xE0 shop@", (_c = this.props.company) === null || _c === void 0 ? void 0 : _c.toLowerCase(), ".com ou appelez-nous au\xA0", COMPANY_PHONES.ca.number, "."]
            })]
          })
        });
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react_1.default.Component);

exports.default = ErrorBoundary;